import { Img } from "Components/Img";
import Tooltip from "./Tooltip";
import { VERIFIED2_ICON } from "Assets/icons";
import { useIntl } from "react-intl";

const RFQVerifyTooltip = ({ isVerified }: { isVerified: boolean }) => {
  const t = useIntl();

  if (!isVerified) return null;

  return (
    <Tooltip
      title={t.formatMessage({
        id: isVerified
          ? "sourcing_request_is_verified_by_freshdi"
          : "verifying",
      })}
    >
      <Img src={VERIFIED2_ICON} alt="icon" className="verify-icon" />
    </Tooltip>
  );
};

export default RFQVerifyTooltip;
